<template>
  <div id="goals-client-form">
    <div class="row mb-4">
      <div class="col-12">
        <div class="input-group input-group-alternative input-group-merge">
          <input class="form-control" v-model="findClient" placeholder="Buscar cliente por nome" type="text" />
          <div class="input-group-prepend">
            <span class="input-group-text">
              <i class="fas fa-search"></i>
            </span>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6 mt-2">
        <el-tooltip content="Saldo adicional" placement="top">
          <badge type="default" size="lg" class="badge-card">
            <span>Saldo adicionado:</span>
            <badge type="success" size="sm" class="badge-subcard">
              {{ (goal.volume || 0).toLocaleString("pt-BR") }}
            </badge>
          </badge>
        </el-tooltip>
      </div>
      <div class="col-12 col-lg-6 mt-2">
        <el-tooltip
          :content="`Saldo Open${isSaldoOpenValid ? '' : ` precisa ser no máximo ${((goal.volume || 0) * 0.3).toLocaleString('pt-BR', { maximumFractionDigits: 2 })}`}`"
          placement="top">
          <badge :type="isSaldoOpenValid ? 'info' : 'warning'" size="lg" class="badge-card">
            <span class="mr-2">Saldo open:</span>
            <badge :type="isSaldoOpenValid ? 'default' : 'danger'" size="sm" class="badge-subcard">
              <span>{{ (openVolume || 0).toLocaleString("pt-BR") }}</span>
            </badge>
          </badge>
        </el-tooltip>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-3">
        <base-progress :value="distributedGoalPercentage"
          :type="goalsClientsTotalVolume < ((goal.volume / 100) * 80) ? 'warning' : 'success'" :height="8" showLabel
          label="Volume distribuído deve ser igual ou maior que 80%"></base-progress>
      </div>
      <div class="col-12 col-lg-3">
        <h6 class="modal-title mb-3" id="exampleModalLabel">Volume distribuído:</h6>
        <base-input :value="goalsClientsTotalVolume | number" input-classes="form-control-sm" class="mb--"
          :disabled="true" mask="integer"></base-input>
      </div>
      <div class="col-12 col-lg-3">
        <h6 class="modal-title mb-3" id="exampleModalLabel">Volume Estratégico:</h6>
        <base-input v-model="goal.volume_estrategico" input-classes="form-control-sm" mask="integer"
          :disabled="!anosafra.is_open">
        </base-input>
        <small class="text-danger small-tooltip2" v-if="!isSaldoEstrategicoValid">O estratégico não pode ser maior que o volume total</small>
      </div>
      <div class="col-12 col-lg-3">
        <h6 class="modal-title mb-3" id="exampleModalLabel">Volume da meta total:</h6>
        <base-input v-model="goal.volume" input-classes="form-control-sm" mask="integer"
          :disabled="!anosafra.is_open"></base-input>
      </div>
    </div>

    <div class="row tableStyle table-striped">
      <div class="col mb-2">
        <h6 class="modal-title mb-3" id="exampleModalLabel">Cliente:</h6>
      </div>
      <div class="col d-flex flex-column align-items-end mb-2">
        <span class="mr-2 text-end">Quantos clientes você quer ver por página?</span>
        <div class="d-flex justify-content-end my-2">
          <base-button v-for="item in [2, 5, 10]" :key="item" :outline="pagination.per_page != item"
            @click="pagination.per_page = item;  pagination.current = 1; getClients()" type="success" size="sm"
            class="mr-2">
            {{ item }}
          </base-button>
        </div>
      </div>
    </div>
    <base-alert class="mt-2" type="warning" v-if="clients.length == 0 && !isLoadingClients">
      <strong >Clientes não encontrados!</strong> Verifique se a carteira de clientes de "{{salesman.name}}" possui
      clientes no anosafra "{{anosafra.descricao}}"
    </base-alert>
    <div id="client-list" class="div-striped" v-loading="isLoadingClients || isLoadingGoalsClients">
      <div v-for="(client, index) in clients" :key="index" class="row mx-0" style="min-width: 750px;">
        <div class="col">
          <div class="name-wrapper mb--3 mt-4">{{client.razao_social}}</div>
        </div>
        <div class="col-2 px-1">
          <base-input
            :value="(prevGoalsClientsHash && prevGoalsClientsHash[client.id] && prevGoalsClientsHash[client.id].volume || 0).toLocaleString('pt-BR', {maximumFractionDigits: 2})"
            input-classes="form-control-sm" class="mb--3" disabled label="Meta:"></base-input>
        </div>
        <div class="col-2 px-1">
          <base-input
            :value="(realizedGoalsHash[client.id] && realizedGoalsHash[client.id].quantidade || 0).toLocaleString('pt-BR', {maximumFractionDigits: 2})"
            input-classes="form-control-sm" class="mb--3" disabled label="Realizado:"></base-input>
        </div>
        <div class="col-2 pl-1">
          <base-input placeholder="Volume" 
            v-model="goalsClientsHash[client.id].volume" 
            input-classes="form-control-sm"
            :class="['mb-3', { 'color-field-volume': goalsClientsHash[client.id].volume > 0 }]"
            :min="0" 
            label="Volume:" 
            mask="integer"
            :disabled="!anosafra.is_open || isLoadingGoalsClients">
          </base-input>
        </div>
      </div>
    </div>
    <hr class="mt-2 mb-3" />
    <div class="row" style="height: 60px;">
      <div class="col d-flex">
        <base-pagination v-model="pagination.current" :total="pagination.count" class="col"
        :perPage="pagination.per_page"></base-pagination>
      </div>
      <div v-if="this.pagination.per_page != 2" class="col d-flex justify-content-end d-none">
        <strong>Total: </strong>
        <span class="ml-1">{{goalsClientsTotalVolume.toLocaleString('pt-BR', {maximumFractionDigits: 2})}}</span>
      </div>
    </div>
    <div class="float-right mt-4">
      <base-button class="mr-3 mb-3" type="secondary" @click="closeForm">Fechar</base-button>
      <el-tooltip :disabled="isSaldoOpenValid"
        :content="`Saldo Open precisa ser no máximo ${((goal.volume || 0) * 0.3).toLocaleString('pt-BR', {maximumFractionDigits: 2})}`"
        placement="top">
        <base-button class="mb-3" type="success" 
          :disabled="goalsClientsTotalVolume < ((goal.volume / 100) * 80) || !isSaldoOpenValid || !isSaldoEstrategicoValid" :loading="isSaving"
          @click="onSave">Salvar</base-button>
      </el-tooltip>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    salesman: {
      type: Object,
      required: true,
    },
    preferredproduct: {
      type: Object,
      required: true,
    },
    anosafra: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    pagination: {
      current: 1,
      count: 0,
      per_page: 5,
    },
    clients: [],
    findClient: "",
    filteredClients: "",
    isLoadingClients: false,
    isLoadingGoalsClients: false,
    isLoadingRealizedGoals: false,
    isSaving: false,
    goalsClients: [],
    prevGoalsClients: [],
    realizedGoals: [],
    errors: [],
    sum: ""
  }),
  mounted() {
    this.getClients()
    this.getGoalsClients()
  },
  methods: {
    async getClients(query = "") {
      this.isLoadingClients = true
      try {
        const response = await this.$http.secured.get("/api/v1/clients", {
          params: {
            q: {
              anosafra_ids: this.anosafra.id,
              salesman_id: this.salesman.id,
              razao_social: query
            },
            page: this.pagination.current,
            per_page: this.pagination.per_page,
            with_goals_data: true,
            previous_anosafra: true,
            anosafra_id: this.anosafra.id,
            preferredproduct_id: this.preferredproduct.id,
            salesman_id: this.salesman.id,
          },
        })
        this.pagination.per_page = response.data.per_page;
        this.pagination.count = response.data.count;
        this.clients    = response.data.clients || [];

        this.clients.forEach(client => {
          if(!this.goalsClients.find(goal => goal.client_id == client.id)){
            this.goalsClients = [...(this.goalsClients || []), {
              volume: 0,
              client_id: client.id,
              anosafra_id: this.anosafra.id,
              salesman_id: this.salesman.id,
              preferredproduct_id: this.preferredproduct.id,
            }]
          }
        });
      } catch (error) {}
      this.isLoadingClients = false
    },
    closeForm() {
      this.findClient = "";
      this.errors = [];
      this.$emit('close');
    },
    async getGoalsClients() {
      this.isLoadingGoalsClients = true
      this.goalsClients = []
      const data = {
        q: {
          anosafra_id: this.anosafra.id,
          salesman_id: this.salesman.id,
          preferredproduct_id: this.preferredproduct.id,
          region_only: true,
        }
      }
      try {
        const responses = await Promise.all([
          this.$http.secured.get("/api/v1/goals_clients", { params: data }),
          this.$http.secured.get("/api/v1/goals_clients", { params: {...data, previous_anosafra: true} }),
        ])

        this.goalsClients = responses[0].data;
        this.prevGoalsClients = responses[1].data;
      } catch (error) { console.error(error) }
      this.isLoadingGoalsClients = false
    },

    /** Save goals_clients */
    async update(goalsClients) {
      this.isSaving = true

      for (const goal of goalsClients) {
        if (!goal.volume) goal.volume = 0;

        try {
          await this.$http.secured.put(`/api/v1/goals_clients/${goal.id}`, goal)
        } catch (error) {
          console.error("Não foi possível atualizar a meta de cliente", goal, error);

          this.errors = error.response.data.errors;
          this.isSaving = false

          throw error;
        }
      }
      this.isSaving = false
    },
    onSave() {
      this.$emit('save-clicked');
      this.save();
    },
    async save() {
      const goalsUpdate = this.goalsClients.filter(g => (g.id && parseFloat(g.volume)))

      try {
        await this.update(goalsUpdate);
      } catch (error) {
        return;
      }

      this.isSaving = true
      const data = {
        goals_client: this.goalsClients.filter(g => !(g.id && parseFloat(g.volume || 0)))
      }

      if (data.goals_client.length === 0) {
        this.onSaveSuccess();

        return;
      }

      try {
        await this.$http.secured.post("/api/v1/goals_clients/create_multiple", data);
        this.onSaveSuccess();
      } catch (error) {
        console.error("Não foi possível atualizar as metas dos clientes", data, error);
        this.errors = error.response.data.errors
        this.$toasted.global.defaultError({ msg: "Operação falhou!" });
      }

      this.isSaving = false;
    },

    onSaveSuccess() {
      this.$emit('save-success');

      this.$toasted.global.defaultSuccess({ msg: "Metas distribuídas atualizadas com sucesso!" });
      this.isSaving = false
    },

    async getPreferredproductGoalsByClient() {
      this.isLoadingRealizedGoals = true
      if(!this.salesman.id || this.salesman.id == 0) return // Check if salesman is Vegetal
      if(!(this.preferredproduct.id)) return // Check if there is a selected preferredproduct

      const data = {
        previous_anosafra: true,
        anosafra_id: this.anosafra.id,
        salesman_id: this.salesman.id,
        preferredproduct_id: this.preferredproduct.id,
        client_id: this.clients.map(client => client.id),
      }
      const response = await this.$http.secured.get("/api/v1/report/preferredproduct_goals_by_client", {params: data})
      this.realizedGoals = response.data
      this.isLoadingRealizedGoals = false
    },

    /** soma de inputs em meta por cliente */
    calcInputSaldoOpen(saldoOpen) {
      if(!(saldoOpen && saldoOpen.length)) return 0

      return saldoOpen.reduce((acumulador, elemento) => acumulador + parseInt(elemento), 0)
    },
  },
  computed: {
    goal() {
      return this.preferredproduct.salesmanGoal || {}
    },
    goalTotalValue() {
      return (this.goal.volume || 0) * (this.preferredproduct.unitary_price || 0)
    },
    goalsClientsTotalValue() {
      return (this.goalsClientsTotalVolume * (this.preferredproduct.unitary_price || 0))
    },
    distributedGoalPercentage() {
      if (this.goal.volume == 0)
        return 0
      else
        return (parseFloat(((this.goalsClientsTotalVolume * 100)/this.goal.volume).toFixed(2)) || 0)
    },
    openValue() {
      return this.goalTotalValue - this.goalsClientsTotalValue
    },
    openVolume() {
      return this.goal.volume - this.goalsClientsTotalVolume
    },
    goalsClientsTotalVolume() {
      return this.goalsClients.reduce((prev, goal) => prev + (parseFloat(goal.volume) || 0), 0)
    },
    goalsClientsHash() {
      return this.goalsClients.reduce((prev, goal) => ({...prev, [goal.client_id]: goal}), {}) || {}
    },
    prevGoalsClientsHash() {
      return this.prevGoalsClients.reduce((prev, goal) => ({...prev, [goal.client_id]: goal}), {}) || {}
    },
    realizedGoalsHash() {
      return this.realizedGoals.reduce((prev, goal) => ({...prev, [goal.client_id]: goal}), {})
    },
    isSaldoOpenValid() {
      if(this.openValue == 0 && this.goalTotalValue == 0) return true

      return (this.openValue / this.goalTotalValue) <= 0.3 && this.openValue >= 0
    },
    isSaldoEstrategicoValid(){
      return this.goal.volume >= this.goal.volume_estrategico;
    }
  },
  watch: {
    'clients': function() {
      this.getPreferredproductGoalsByClient()
    },
    'pagination.current': function() {
      this.getClients()
    },
    preferredproduct: async function(){
      await this.getGoalsClients()
      await this.getClients()
    },
    'findClient': function (razao_social){
      this.getClients(razao_social)
    },
    'goal.volume': function (volume) {
      if (volume == 0 | !volume) {
        this.goal.volume_estrategico = 0
      }
    }
  },
};
</script>

<style>

.color-field-volume{
  input.form-control{
    background-color: #2dce89;
    color: #fff
  }
}

#goals-client-form div.div-striped>div:nth-of-type(odd) {
  background: #F5F5F5;
}

#goals-client-form #client-list {
  /* max-height: 300px;
  max-height: calc(70vh - 147.4px - 68px - 52px - 43px); */
  min-height: 140px;
  overflow-y: auto;
  overflow-x: auto;
}

.small-tooltip2 {
  position:absolute;
  background-color: #f8d7da; 
  border-radius: 4px; 
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2); 
  white-space: nowrap; 
  top: 70px;
}

.badge-subcard {
  font-size: 14px; 
  overflow: hidden; 
  width: fit-content;  
  margin-left: 3px; 
  margin-bottom: -5px; 
  margin-top: -3px;
}

.badge-card {
  width: 100%; 
  font-size: 12px;
}
</style>
